import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useInView from "../hooks/useInView";

function FeaturedYachts() {
    const [sectionRef, isInView] = useInView();
    const [yachts, setYachts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [imageErrors, setImageErrors] = useState({});

    useEffect(() => {
        fetch("/rest/yacht/getAllYachts")
            .then((res) => res.json())
            .then((data) => {
                // İlk 4 yatı al
                const featuredYachts = Array.isArray(data) ? data.slice(0, 4) : data.value ? data.value.slice(0, 4) : [];
                setYachts(featuredYachts);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Yatlar yüklenirken hata oluştu:", error);
                setLoading(false);
            });
    }, []);

    // Resim URL'ini oluşturan yardımcı fonksiyon
    const getImageUrl = (yacht) => {
        // Yeni format - yachtImages
        if (yacht.yachtImages && yacht.yachtImages.length > 0) {
            return `https://cyprusyachtclub.com/rest-images/YachtImages/${yacht.yachtImages[0].imageUrl}`;
        }
        // Eski format - fotoLinks
        if (yacht.fotoLinks && yacht.fotoLinks.length > 0) {
            return yacht.fotoLinks[0];
        }
        return null;
    };

    // Resim yükleneme durumunu yöneten fonksiyon
    const handleImageError = (yachtId) => {
        setImageErrors(prev => ({
            ...prev,
            [yachtId]: true
        }));
    };

    // Placeholder görselini render eden fonksiyon
    const renderPlaceholder = (yachtName) => (
        <div className="w-full h-56 bg-gradient-to-br from-blue-600/20 to-blue-800/20 flex items-center justify-center">
            <div className="text-center text-white">
                <svg className="w-12 h-12 mx-auto mb-2" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M3 13h1l1 2h2l1-2h2l1 2h2l1-2h2l1 2h2l1-2h2l1 2h1v1c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-1z"/>
                    <path d="M12 2l-1 3v6h2V5l-1-3zm4 8l-1-3v6h2V8l-1-2zm-8 0l-1-2v4h2V8l-1-2z"/>
                    <path d="M12 10v3"/>
                </svg>
                <p className="text-xs opacity-80">{yachtName}</p>
            </div>
        </div>
    );

    if (loading) {
        return (
            <section className="py-16 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4">
                    <h2 className="text-4xl font-bold text-center mb-12">
                        Öne Çıkan Yatlarımız
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {[...Array(4)].map((_, index) => (
                            <div
                                key={index}
                                className="bg-white rounded-lg shadow-lg overflow-hidden animate-pulse"
                            >
                                <div className="w-full h-64 bg-gray-300"></div>
                                <div className="p-6 space-y-4">
                                    <div className="h-6 bg-gray-300 rounded w-3/4"></div>
                                    <div className="h-4 bg-gray-300 rounded w-1/2"></div>
                                    <div className="flex justify-between items-center">
                                        <div className="h-6 bg-gray-300 rounded w-1/3"></div>
                                        <div className="h-10 bg-gray-300 rounded w-1/4"></div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="py-16 bg-gray-50">
            <div
                ref={sectionRef}
                className={`max-w-7xl mx-auto px-4 fade-in-section ${
                    isInView ? "is-visible" : ""
                }`}
            >
                <h2 className="text-4xl font-bold text-center mb-12">
                    Öne Çıkan Yatlarımız
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 px-4">
                    {yachts.map((yacht) => (
                        <div
                            key={yacht.id}
                            className="bg-white rounded-xl shadow-lg overflow-hidden group hover:shadow-xl transition-all duration-300"
                        >
                            <div className="relative overflow-hidden">
                                {!imageErrors[yacht.id] && getImageUrl(yacht) ? (
                                    <>
                                        <img
                                            src={getImageUrl(yacht)}
                                            alt={yacht.name || yacht.ad}
                                            className="w-full h-56 object-cover transform group-hover:scale-110 transition-transform duration-500"
                                            onError={() => handleImageError(yacht.id)}
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                    </>
                                ) : (
                                    renderPlaceholder(yacht.name || yacht.ad)
                                )}
                            </div>
                            <div className="p-6">
                                <h3 className="text-xl font-semibold mb-2">
                                    {yacht.name || yacht.ad}
                                </h3>
                                <p className="text-gray-500 text-sm mb-4">
                                    {yacht.length || yacht.uzunluk} metre / {yacht.capacity || yacht.kapasite}{" "}
                                    misafir
                                </p>
                                <div className="flex justify-between items-center">
                                    <span className="text-blue-600 text-sm font-medium">
                                        {yacht.model} {yacht.year || yacht.yil}
                                    </span>
                                    <Link
                                        to={`/yachts/${yacht.id}`}
                                        className="bg-gradient-to-r from-blue-600 to-blue-500 text-white text-sm px-4 py-2 rounded-lg hover:shadow-lg hover:shadow-blue-500/30 transition-all duration-300 transform hover:-translate-y-0.5"
                                    >
                                        Detaylar
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default FeaturedYachts;
